import React, { Component } from 'react';
import AudioAnalyser from 'react-audio-analyser';
import $ from 'jquery';
import { toggleSubmitActive } from '../../../../redux/testPage/testPage.actions';
import { setResetCounter } from '../../../../redux/utilities/utils.actions';
import { handleBlobChange } from '../../../../redux/utilities/utils.actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { stopAllAudio, enableAudio } from '../../../../utils/commonFunctions';
import Loader from '../../../../utils/Loader';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

class AudioRecorder extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: '',
			audioSrc: '',
			isMicPermitted: false,
			percentage: 0,
			rrConfirm: false
		};
		this.controlAudio = this.controlAudio.bind(this);
		this.audioStopTimeout = undefined;
		this.audioRecordStartTime = 0
		this.audioRecordDurationTime = 0
		this.timeCount = 0
	}

	controlAudio(status) {
		this.setState({
			status,
		});
	}

	initRecording(status) {
		if (this.state.audioSrc === '') {
			this.controlAudio(status)
		} else {
			this.setState({
				rrConfirm: true
			});
		}
	}

	warningAction(action) {
		if(action === 'reset') {
			this.controlAudio('recording')
		}

		this.setState({
			rrConfirm: false
		});
	}

	componentWillUnmount() {
		clearTimeout(this.audioStopTimeout)
	}

	render() {
		const { status, audioSrc } = this.state;

		const {
			clozeConvo,
			resetCounter,
			resetCounters,
			index,
			handleBlobChange,
			toggleSubmitActive,
			updateCounters,
			updateCounter,
			qtype,
			qdomain
		} = this.props;
		const timeoutDuration = (qtype === 'LA' && qdomain === 'S' && (localStorage.getItem('active_course_id') === '659' || localStorage.getItem('active_course_id') === '652' || localStorage.getItem('active_course_id') === '489' || localStorage.getItem('active_course_id') === '669')) ? 60000 : 30000;
		var videoTimer = 0;
		var videoMaxTime = timeoutDuration / 1000;

		const audioProps = {
			audioOptions: { sampleRate: 16000, channels: 1, kbps: 16 },
			status,
			audioSrc,
			width: 640,
			height: 60,
			strokeColor: '#063B63',
			backgroundColor: '#5BBFB3',
			audioType: 'audio/webm',
			audioBitsPerSecond: 16000,
			// timeslice: 1000,
			startCallback: (e) => {

				this.audioRecordStartTime = Date.now()

				this.timeCount = 0
				this.setState({
					percentage: 0
				})

				this.audioInterval = setInterval(() => {
					this.timeCount++

					if (this.state.percentage < 100) {
						this.setState({
							percentage: ((this.timeCount * 1000) / timeoutDuration) * 100
						})

					} else if (this.state.percentage >= 100) {
						clearInterval(this.audioInterval)
						$(`.audioRecorder .icon-stop`).click();
					}

				}, 1000)

				this.audioStopTimeout = setTimeout(() => {
					if (!!index) {
						$(`.audioRecorder[index!=${index}] .icon-stop`).click();
					} else {
						$(`.audioRecorder .icon-stop`).click();
					}
				}, timeoutDuration);

				stopAllAudio();
				$(`.audioRecorder[index=${index}]`).closest('.speaking-question').focus();
				if (typeof index !== 'undefined') {
					let recorders = $(`.audioRecorder[index!=${index}] .icon-stop`);

					for (var i = 0, len = recorders.length; i < len; i++) {
						recorders[i].click();
					}
				}

			},
			pauseCallback: (e) => {
				console.log('succ pause', e);
			},
			stopCallback: (e) => {
				Loader.show();
				this.timeCount = 0
				clearInterval(this.audioInterval)
				clearTimeout(this.audioStopTimeout)

				let durTime = Date.now() - this.audioRecordStartTime
				this.audioRecordDurationTime = (durTime - (durTime % 1000)) / 1000;

				if (!!resetCounter) {
					updateCounter();
				} else if (!!resetCounters && resetCounters.length > 0) {
					updateCounters(index);
				}

				this.setState({
					audioSrc: window.URL.createObjectURL(e),
				});

				handleBlobChange({ blob: e, index });

				//added for individual reset
				if (clozeConvo) {
					if ($('.converse-nil')) {
						$('.converse-nil').focus();
					}
				} else {
					if (qtype.toLowerCase() === 'wordcloud') {
						if (!$('.arrange-words-inposition span').hasClass('avail'))
							toggleSubmitActive(false);
					} else if (qtype.toLowerCase() === 'cloze_with_passage') {
						if (!$('.quiz-area-options span').hasClass('to-be-filled'))
							toggleSubmitActive(false);
					} else toggleSubmitActive(false);
				}

				if (!$('.icon-stop').is(':visible')) {
					enableAudio();
				}
				Loader.hide();

				const _audioCont = document.getElementsByClassName("audioContainer")

				for (var ai = 0; ai < _audioCont.length; ai++) {
					let _audio = _audioCont[ai].querySelector("audio")
					if (_audio && _audio.src === this.state.audioSrc) {
						_audio.preload = true
						_audio.currentTime = _audio.currentTime === 0 ? this.audioRecordDurationTime : 0
						setTimeout(() => {
							_audio.currentTime = 0
						}, 1000)
					}
				}
				videoTimer = 0;
			},
			onRecordCallback: (e) => {
				videoTimer++;
				if (videoTimer >= videoMaxTime) {
					if (!!index) {
						$(`.audioRecorder[index=${index}] .icon-stop`).click();
					} else {
						$(`.audioRecorder .icon-stop`).click();
					}
					videoTimer = 0;
				}
			},
			errorCallback: (err) => {
				console.log('error', err);
			},
		};



		return (
			<>
				<div className={`reloadWarning-Container ${this.state.rrConfirm ? 'active' : ''}`}>
					<div className="reloadWarning">
						<div className="reloadWarningChild">
							<p className="test-infor transition-item">Note<span>You are re-recording your response. Previous recording(s) will be discarded.</span></p>
						</div>
						<div className="but">
							<button className="btn btn-lg btn-info go-next btn-primary" onClick={() => this.warningAction('reset')}>Reset</button>
							<button className="btn btn-lg btn-info go-next btn-primary" onClick={() => this.warningAction('cancel')}>Cancel</button>
						</div>
					</div>
				</div>

				<div className='audioRecorderContainer'>
					<div className="audioRecorder" index={index}>
						<div key={resetCounters[index]} className="btn-box">

							<div className="circularProgressContainer">
								<CircularProgressbar value={this.state.percentage} />
							</div>

							{status !== 'recording' && (
								<button
									aria-label="start-recording"
									onClick={() => this.initRecording('recording')}
									// onClick={() => this.controlAudio('recording')}
									className={`iconfont icon-start icon-start_cloze icon_start_${index} `}
								></button>
							)}
							{status === 'recording' && (
								<>
									<button
										aria-label="stop-recording"
										className="iconfont icon-stop"
										onClick={() => this.controlAudio('inactive')}
									></button>
									<div className='recording-min-sec'>{Math.trunc(this.timeCount / 60) < 10 ? '0' : ''}{Math.trunc(this.timeCount / 60)}:{this.timeCount % 60 < 10 ? '0' + this.timeCount % 60 : this.timeCount % 60}</div>
								</>
							)}
						</div>
					</div>

					<AudioAnalyser
						style={{ width: '60px', height: '60px' }}
						{...audioProps}
					></AudioAnalyser>
				</div>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		rightSectionProps: { resetCounter, resetCounters },
		leftSectionProps: { qdomain, qtype },
		questionNo,
		isMicPermitted,
	} = state.rootReducer.testPageDetails;

	return {
		resetCounter,
		resetCounters,
		questionNo,
		isMicPermitted,
		qtype,
		qdomain
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleSubmitActive: (val) => dispatch(toggleSubmitActive(val)),
		setResetCounter: (val) => dispatch(setResetCounter(val)),
		handleBlobChange: ({ blob, index }) =>
			dispatch(handleBlobChange({ blob, index })),
	};
};
export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(AudioRecorder);
